import { logEvent } from '@coverright/shared/analytics';
import { enqueueSnackbar } from 'notistack';
import { removePlansFromApolloCache } from './lib';
import {
  DrugDeliveryTypeDto,
  PharmacyLocationDistanceOutput,
} from '@coverright/data-access/types/medicare';
import { ClientDrugDeliveryType } from '@coverright/data-access/types/enrollment';
import {
  enrollmentApolloClient,
  mainBackendApolloCache,
  mainBackendApolloClient
} from '@coverright/data-access/apollo-clients';
import { MedicareQuoteQuery } from '@coverright/data-access/medicare';
import { usePatchClientPersonalInfoMutation } from '@coverright/data-access/enrollment';

export function useSavePharmacies(quote: MedicareQuoteQuery['medicareQuote']) {
  const [mutation] = usePatchClientPersonalInfoMutation({ client: enrollmentApolloClient });

  return async (
    pharmacies: PharmacyLocationDistanceOutput[],
    type?: DrugDeliveryTypeDto
  ) => {
    if (quote) {
      if ((window as any).track && pharmacies.length) {
        logEvent('Pharmacies Added', {
          pharmacies: pharmacies,
          location: 'Plan finder',
        });
      }

      const preferredPharmacies =
        type === DrugDeliveryTypeDto.Pharmacy ? pharmacies : [];

      try {
        await mutation({
          variables: {
            clientId: quote.clientId,
            preferredPharmacies: preferredPharmacies.map((p) => p.npi),
            drugDeliveryType: type as unknown as ClientDrugDeliveryType,
          },
          optimisticResponse: (vars) => {
            return {
              patchClientPersonalInfo: true,
            };
          },
          update: () => {
            mainBackendApolloCache.modify({
              id: mainBackendApolloCache.identify(quote),
              fields: {
                drugDeliveryType(cached) {
                  return type || cached;
                },
                preferredPharmacies(cached, {toReference}) {
                  return preferredPharmacies.map((p) => toReference({
                    __typename: 'PharmacyLocationDistanceOutput',
                    npi: p.npi
                  }));
                },
              }
            })
          }
        });

        setTimeout(() => {
          removePlansFromApolloCache();

          mainBackendApolloClient.refetchQueries({
            include: ['medicareQuote', 'pdpQuote'],
          });
        }, 1000)

        enqueueSnackbar('Pharmacies has been saved', { variant: 'success' });
      } catch (e) {
        enqueueSnackbar('Error saving pharmacies', { variant: 'error' });
      }
    } else {
      throw Error('Medicare quote is not exists');
    }
  };
}
